import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
    mostraAlertaError,
    mostraAlertaOk
} from "../../../../componentes/alerts/sweetAlert";
import { AxiosPrivado } from "../../../../componentes/axios/Axios";
import Card from "../../../../componentes/contenedores/Card";
import ModalBootstrap from "../../../../componentes/modal/ModalBootstrap";
import Page from "../../../../componentes/plantilla/Page";
import {
    ImagenProducto,
    PromocionesEditar,
    PromocionesListar
} from "../../../../configuracion/apiUrls";
import { useContextEmpleado } from "../../../../contexto/empleado/EmpleadoContext";

const EditarPromocion = () => {
    const { token, ActualizarLista, listaProductos, setListaPromociones } = useContextEmpleado();
    const location = useLocation();
    const navigate = useNavigate();
    const { datos } = location.state || {};
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [formularioPromocion, setFormularioPromocion] = useState({
        id: null,
        nombre: "",
        descripcion: "",
        tipo: "Unico",
        fechaInicio: "",
        fechaFin: "",
        hora_inicio: "",
        hora_fin: "",
        diasSemana: "",
        estado: "Activo",
        descuento: "5%",
        descuentoTotal: 0,
        limite_total: 0,
        limite_cliente: 0,
        promocionDetalle: [],
    });

    const [errorNombre, setErrorNombre] = useState(false);
    const [errorDescripcion, setErrorDescripcion] = useState(false);
    const [errorFechaInicio, setErrorFechaInicio] = useState(false);
    const [errorFechaFin, setErrorFechaFin] = useState(false);
    const [errorHoraInicio, setErrorHoraInicio] = useState(false);
    const [errorHoraFin, setErrorHoraFin] = useState(false);
    const [errorLimiteTotal, setErrorLimiteTotal] = useState(false);
    const [errorLimiteCliente, setErrorLimiteCliente] = useState(false);
    const [productoSearchTerm, setProductoSearchTerm] = useState("");
    const [cantidadProducto, setCantidadProducto] = useState(1);
    const [paginaActualModal, setPaginaActualModal] = useState(1);
    const dias = ["Todos", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"];
    const [productosDisponibles, setProductosDisponibles] = useState([]);
    const [mostrarDetalleProductos, setMostrarDetalleProductos] = useState(false);

    const transformarProductos = (list) =>
            Array.isArray(list) && list.length > 0
                ? list.map((p) => ({
                    id: p.id,
                    nombre: p.nombre,
                    descripcion: p.descripcion,
                    precio: p.precio,
                    existencia: p.existencia,
                    tipo: p.tipo,
                    codigo: p.codigo,
                    imagen: p.productoImagens?.[0]?.imagen
                        ? ImagenProducto + p.productoImagens[0].imagen
                        : "/productos.jpg",
                }))
            : [];
    
    useEffect(() => {
        setProductosDisponibles(transformarProductos(listaProductos));
    }, [listaProductos]);

    useEffect(() => {
        if (datos) {
            setFormularioPromocion({
                id: datos.id || null,
                nombre: datos.nombre || "",
                descripcion: datos.descripcion || "",
                tipo: datos.tipo || "Unico",
                fechaInicio: datos.fechaInicio ? datos.fechaInicio.split('T')[0] : "",
                fechaFin: datos.fechaFin ? datos.fechaFin.split('T')[0] : "",
                hora_inicio: datos.hora_inicio || "",
                hora_fin: datos.hora_fin || "",
                diasSemana: datos.diasSemana || "",
                estado: datos.estado || "Activo",
                descuento: datos.descuento || "5%",
                descuentoTotal: datos.descuentoTotal || 0,
                limite_total: datos.limite_total || 0,
                limite_cliente: datos.limite_cliente || 0,
                promocionDetalle: datos.detallepromocions ? datos.detallepromocions.map(detalle => ({
                    productoId: detalle.productoId,
                    nombre: detalle.producto.nombre,
                    cantidad: detalle.cantidad,
                    precio: parseFloat(detalle.precioPromocion),
                    precioOriginal: parseFloat(detalle.producto.precio),
                    precioManual: false, 
                })) : [],
            });
        }
    }, [datos]);

    const manejadorPromocion = (event) => {
        const { name, value } = event.target;
        setFormularioPromocion((prev) => ({
            ...prev,
            [name]: value,
        }));
        if (name === "nombre") setErrorNombre(false);
        if (name === "descripcion") setErrorDescripcion(false);
        if (name === "fechaInicio") setErrorFechaInicio(false);
        if (name === "fechaFin") setErrorFechaFin(false);
        if (name === "hora_inicio") setErrorHoraInicio(false);
        if (name === "hora_fin") setErrorHoraFin(false);
        if (name === "limite_total") setErrorLimiteTotal(false);
        if (name === "limite_cliente") setErrorLimiteCliente(false);
        if (name === "descuento") {
            aplicarDescuentoProductos(value);
        }
    };

    const aplicarDescuentoProductos = (descuentoStr) => {
        const porcentaje = parseFloat(descuentoStr.replace("%", "")) || 0;
        const factor = 1 - porcentaje / 100;
        setFormularioPromocion((prev) => ({
            ...prev,
            promocionDetalle: prev.promocionDetalle.map((producto) => {
                if (producto.precioManual) return producto;
                const nuevoPrecio = producto.precioOriginal * factor;
                return {
                    ...producto,
                    precio: parseFloat(nuevoPrecio.toFixed(2)),
                };
            }),
        }));
    };

    const handleDiasSemanaChange = (dia, checked) => {
        let seleccionados = formularioPromocion.diasSemana.split(",").filter(Boolean);
        if (checked) {
            if (dia === "Todos") {
                seleccionados = ["Todos"];
            } else {
                seleccionados = seleccionados.filter((d) => d !== "Todos");
                if (!seleccionados.includes(dia)) {
                    seleccionados.push(dia);
                }
            }
        } else {
            seleccionados = seleccionados.filter((d) => d !== dia);
        }
        setFormularioPromocion((prev) => ({
            ...prev,
            diasSemana: seleccionados.join(","),
        }));
    };

    const editarPromocion = async () => {
        let hasError = false;
        if (!formularioPromocion.nombre.trim()) {
            setErrorNombre(true);
            hasError = true;
        }
        if (!formularioPromocion.descripcion.trim()) {
            setErrorDescripcion(true);
            hasError = true;
        }
        if (!formularioPromocion.fechaInicio) {
            setErrorFechaInicio(true);
            hasError = true;
        }
        if (!formularioPromocion.fechaFin) {
            setErrorFechaFin(true);
            hasError = true;
        }
        if (
            formularioPromocion.fechaInicio &&
            formularioPromocion.fechaFin &&
            new Date(formularioPromocion.fechaInicio) > new Date(formularioPromocion.fechaFin)
        ) {
            setErrorFechaInicio(true);
            setErrorFechaFin(true);
            mostraAlertaError("Validación", "La fecha de inicio no puede ser posterior a la fecha de fin.");
            hasError = true;
        }
        if (!formularioPromocion.hora_inicio) {
            setErrorHoraInicio(true);
            hasError = true;
        }
        if (!formularioPromocion.hora_fin) {
            setErrorHoraFin(true);
            hasError = true;
        }
        if (
            formularioPromocion.limite_total &&
            (isNaN(parseFloat(formularioPromocion.limite_total)) || parseFloat(formularioPromocion.limite_total) < 0)
        ) {
            setErrorLimiteTotal(true);
            hasError = true;
        }
        if (
            formularioPromocion.limite_cliente &&
            (isNaN(parseFloat(formularioPromocion.limite_cliente)) || parseFloat(formularioPromocion.limite_cliente) < 0)
        ) {
            setErrorLimiteCliente(true);
            hasError = true;
        }
        if (hasError) {
            mostraAlertaError("Validación", "Por favor, corrige los errores en el formulario.");
            return;
        }
        try {
            const payload = {
                id: formularioPromocion.id,
                nombre: formularioPromocion.nombre,
                descripcion: formularioPromocion.descripcion,
                tipo: formularioPromocion.tipo,
                fechaInicio: formularioPromocion.fechaInicio,
                fechaFin: formularioPromocion.fechaFin,
                hora_inicio: formularioPromocion.hora_inicio?.slice(0, 5),
                hora_fin: formularioPromocion.hora_fin?.slice(0, 5),
                diasSemana: formularioPromocion.diasSemana,
                estado: formularioPromocion.estado,
                descuento: formularioPromocion.descuento,
                descuentoTotal: formularioPromocion.descuentoTotal,
                limite_total: formularioPromocion.limite_total === "" ? null : parseInt(formularioPromocion.limite_total),
                limite_cliente: formularioPromocion.limite_cliente === "" ? null : parseInt(formularioPromocion.limite_cliente),
                promocionDetalle: formularioPromocion.promocionDetalle.map((item) => ({
                    productoId: item.productoId,
                    precio: item.precio,
                    cantidad: item.cantidad,
                })),
            };
            AxiosPrivado.defaults.headers.common["Authorization"] = `Bearer ${token}`;
            await AxiosPrivado.put(PromocionesEditar + `?id=${formularioPromocion.id}`, payload);
            mostraAlertaOk("Promoción actualizada correctamente.");
            ActualizarLista(PromocionesListar, setListaPromociones);
            navigate("/app/admin/promociones/editar");
        } catch (error) {
            console.error("Error al actualizar la promoción:", error);
            if (error.response) {
                const { status, data } = error.response;
                if (status === 400 && Array.isArray(data)) {
                    const mensajes = data.map(e => `• ${e.msg}`).join("<br/>");
                    mostraAlertaError("Errores de validación", mensajes);
                    return;
                }
                if (data?.error) {
                    mostraAlertaError("Error", data.error);
                    return;
                }
            }
            mostraAlertaError("Error", "No se pudo actualizar la promoción.");
        }
        
    };    

    const agregarProductoSeleccionado = (producto) => {
        const porcentaje = parseFloat(formularioPromocion.descuento.replace("%", "")) || 0;
        const factor = 1 - porcentaje / 100;
        const precioConDescuento = producto.precio * factor;

        setFormularioPromocion((prev) => {
            const detalleActualizado = prev.promocionDetalle.map(item => {
                if (item.productoId === producto.id) {
                    return {
                        ...item,
                        cantidad: item.cantidad + cantidadProducto
                    };
                }
                return item;
            });
            const yaExiste = prev.promocionDetalle.some(item => item.productoId === producto.id);
            return {
                ...prev,
                promocionDetalle: yaExiste
                    ? detalleActualizado
                    : [
                        ...prev.promocionDetalle,
                        {
                            productoId: producto.id,
                            nombre: producto.nombre,
                            cantidad: cantidadProducto,
                            precio: parseFloat(precioConDescuento.toFixed(2)),
                            precioOriginal: producto.precio,
                            precioManual: false,
                        }
                    ]
            };
        });
        setProductoSearchTerm("");
        setModalIsOpen(false);
    };
    
    const eliminarProducto = (productoId) => {
        setFormularioPromocion((prev) => ({
            ...prev,
            promocionDetalle: prev.promocionDetalle.filter((item) => item.productoId !== productoId),
        }));
    };

    const handleProductoChange = (productoId, field, value) => {
        setFormularioPromocion((prev) => ({
            ...prev,
            promocionDetalle: prev.promocionDetalle.map((item) => {
                if (item.productoId === productoId) {
                    return {
                        ...item,
                        [field]: value,
                        ...(field === "precio" ? { precioManual: true } : {})
                    };
                }
                return item;
            }),
        }));
    };

    const renderDetallePromocionProductos = () => {
        const productosPromocion = formularioPromocion.promocionDetalle;

        return (
            <div className="mt-3 p-3 border rounded">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="mb-0">
                        <i className="fas fa-list me-2 mx-2"></i>Detalle de la Promoción (Productos)
                    </h5>
                    {formularioPromocion.tipo === "Total" && (
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="mostrarDetalle"
                                checked={mostrarDetalleProductos}
                                onChange={(e) => setMostrarDetalleProductos(e.target.checked)}
                            />
                            <label className="form-check-label" htmlFor="mostrarDetalle">
                                Mostrar detalle de productos
                            </label>
                        </div>
                    )}
                </div>

                {(formularioPromocion.tipo !== "Total" || mostrarDetalleProductos) && (
                    <>
                        <ModalBootstrap
                            titulo="Seleccionar Productos para Promoción"
                            nombreBoton="Agregar Producto"
                            estiloBoton="btn btn-primary me-2 mb-3"
                            iconBoton="fas fa-cart-plus"
                            modalIsOpen={modalIsOpen}
                            setModalIsOpen={setModalIsOpen}
                        >
                            <div className="mb-3 d-flex">
                                <div className="col-md-6 col-sm-8">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Buscar producto por nombre o código..."
                                        value={productoSearchTerm}
                                        onChange={(e) => setProductoSearchTerm(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="table-responsive">
                                <table className="table table-bordered table-striped table-hover shadow-sm">
                                    <thead className="bg-dark text-white">
                                        <tr>
                                            <th>Imagen</th>
                                            <th>Nombre</th>
                                            <th>Código</th>
                                            <th>Precio</th>
                                            <th>Agregar</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {productosPagina.length > 0 ? (
                                            productosPagina.map((producto) => (
                                                <tr key={producto.id}>
                                                    <td>
                                                        <img
                                                            src={producto.imagen}
                                                            alt={producto.nombre}
                                                            className="img-thumbnail"
                                                            style={{ width: "50px", height: "50px" }}
                                                        />
                                                    </td>
                                                    <td>{producto.nombre}</td>
                                                    <td>{producto.codigo}</td>
                                                    <td>L {producto.precio}</td>
                                                    <td className="text-center align-middle">
                                                        <button
                                                            className="btn btn-success btn-sm"
                                                            onClick={() => agregarProductoSeleccionado(producto)}
                                                        >
                                                            <i className="fa-solid fa-cart-plus" />
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="5" className="text-center text-muted">
                                                    No se encontraron productos
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                <nav className="mt-2">
                                    <ul className="pagination pagination-sm justify-content-center shadow-sm bg-light p-3 rounded">
                                        <li className={`page-item ${paginaActualModal === 1 ? "disabled" : ""}`}>
                                            <button
                                                className="page-link"
                                                onClick={() => setPaginaActualModal(paginaActualModal - 1)}
                                                aria-label="Anterior"
                                            >
                                                <i className="fas fa-chevron-left me-1"></i> Anterior
                                            </button>
                                        </li>
                                        {[...Array(totalPaginasModal)].map((_, i) => (
                                            <li
                                                key={i}
                                                className={`page-item ${paginaActualModal === i + 1 ? "active" : ""}`}
                                            >
                                                <button className="page-link fw-bold" onClick={() => setPaginaActualModal(i + 1)}>
                                                    {i + 1}
                                                </button>
                                            </li>
                                        ))}
                                        <li className={`page-item ${paginaActualModal === totalPaginasModal ? "disabled" : ""}`}>
                                            <button
                                                className="page-link"
                                                onClick={() => setPaginaActualModal(paginaActualModal + 1)}
                                                aria-label="Siguiente"
                                            >
                                                Siguiente <i className="fas fa-chevron-right ms-1"></i>
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </ModalBootstrap>

                        {productosPromocion && productosPromocion.length > 0 ? (
                            <div className="table-responsive mb-3">
                                <table className="table table-bordered">
                                    <thead className="bg-light">
                                        <tr>
                                            <th>Producto</th>
                                            <th>Cantidad</th>
                                            <th>Precio Original</th>
                                            <th>Precio con Descuento</th>
                                            <th>Subtotal</th>
                                            <th>Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {productosPromocion.map((item) => (
                                            <tr key={item.productoId}>
                                                <td>{item.nombre}</td>
                                                <td>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        min="1"
                                                        value={item.cantidad}
                                                        onChange={(e) =>
                                                            handleProductoChange(
                                                                item.productoId,
                                                                "cantidad",
                                                                Math.max(1, parseInt(e.target.value) || 1)
                                                            )
                                                        }
                                                        style={{ width: "80px" }}
                                                    />
                                                </td>
                                                <td>
                                                    {new Intl.NumberFormat("es-HN", {
                                                        style: "currency",
                                                        currency: "HNL",
                                                    }).format(item.precioOriginal)}
                                                </td>
                                                <td>
                                                    <input
                                                        type="number"
                                                        step="0.01"
                                                        className="form-control"
                                                        min="0"
                                                        value={item.precio}
                                                        onChange={(e) =>
                                                            handleProductoChange(
                                                                item.productoId,
                                                                "precio",
                                                                Math.max(0, parseFloat(e.target.value) || 0)
                                                            )
                                                        }
                                                        style={{ width: "100px" }}
                                                    />
                                                </td>
                                                <td>
                                                    {new Intl.NumberFormat("es-HN", {
                                                        style: "currency",
                                                        currency: "HNL",
                                                    }).format(item.precio * item.cantidad)}
                                                </td>
                                                <td>
                                                    <button
                                                        type="button"
                                                        className="btn btn-danger btn-sm"
                                                        onClick={() => eliminarProducto(item.productoId)}
                                                    >
                                                        <i className="fas fa-trash"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot>
                                        <tr className="bg-light">
                                            <td colSpan="4" className="text-end">
                                                <strong>Total:</strong>
                                            </td>
                                            <td>
                                                <strong>
                                                    {new Intl.NumberFormat("es-HN", {
                                                        style: "currency",
                                                        currency: "HNL",
                                                    }).format(
                                                        productosPromocion.reduce(
                                                            (total, item) => total + item.precio * item.cantidad,
                                                            0
                                                        )
                                                    )}
                                                </strong>
                                            </td>
                                            <td></td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        ) : (
                            <div className="alert alert-info">No hay productos en esta promoción.</div>
                        )}
                    </>
                )}

                {formularioPromocion.tipo === "Total" && !mostrarDetalleProductos && (
                    <div className="alert alert-info">
                        <i className="fas fa-info-circle me-2 mx-2"></i>
                        Las promociones de tipo "Total" se aplican a toda la compra.
                        Activa el checkbox para agregar productos específicos si es necesario.
                    </div>
                )}
            </div>
        );
    };

    const pageData = {
        titulo: {
            titulo: "Editar promoción",
            url: "/app/admin/promociones",
            tituloUrl: "Menú Promociones",
            nombreUrl: "Inicio ",
        },
    };

    const BotonActualizar = () => (
        <button
            type="button"
            className="btn btn-warning"
            onClick={editarPromocion}
        >
            Actualizar Promoción
        </button>
    );

    const filteredProductos = productosDisponibles
        .filter((producto) =>
            (producto.nombre + producto.codigo)
                .toLowerCase()
                .includes(productoSearchTerm.toLowerCase())
        );

    const productosPorPagina = 5;
    const indexUltimo = paginaActualModal * productosPorPagina;
    const indexPrimero = indexUltimo - productosPorPagina;
    const productosPagina = filteredProductos.slice(indexPrimero, indexUltimo);
    const totalPaginasModal = Math.ceil(filteredProductos.length / productosPorPagina);

    return (
        <Page datos={pageData}>
            <div className="row">
                <div className="col-12">
                    <Card titulo="Detalles de la Promoción" pie={<BotonActualizar />}>
                        <div className="row gy-4 gx-3">
                            <div className="col-md-6 mb-3">
                                <label className="form-label">Nombre</label>
                                <input
                                    className={`form-control ${errorNombre ? "is-invalid" : ""}`}
                                    name="nombre"
                                    value={formularioPromocion.nombre}
                                    onChange={manejadorPromocion}
                                    onBlur={() => {
                                        if (!formularioPromocion.nombre.trim()) setErrorNombre(true);
                                    }}
                                />
                                {errorNombre && (
                                    <div className="invalid-feedback">El nombre es requerido.</div>
                                )}
                            </div>
                            <div className="col-md-6 mb-3">
                                <label className="form-label">Descripción</label>
                                <input
                                    className={`form-control ${errorDescripcion ? "is-invalid" : ""}`}
                                    name="descripcion"
                                    value={formularioPromocion.descripcion}
                                    onChange={manejadorPromocion}
                                    onBlur={() => {
                                        if (!formularioPromocion.descripcion.trim()) setErrorDescripcion(true);
                                    }}
                                />
                                {errorDescripcion && (
                                    <div className="invalid-feedback">La descripción es requerida.</div>
                                )}
                            </div>
                            <div className="col-md-4 mb-3">
                                <label className="form-label">Tipo</label>
                                <select
                                    className="form-select mx-1"
                                    name="tipo"
                                    value={formularioPromocion.tipo}
                                    onChange={manejadorPromocion}
                                >
                                    {["Total", "Unico", "Combo", "Evento"].map((op) => (
                                        <option key={op} value={op}>{op}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-md-4 mb-3">
                                <label className="form-label">Descuento</label>
                                <select
                                    className="form-select mx-1"
                                    name="descuento"
                                    value={formularioPromocion.descuento}
                                    onChange={manejadorPromocion}
                                >
                                    {["5%", "10%", "15%", "20%", "25%", "30%", "35%", "40%", "45%", "50%"].map((op) => (
                                        <option key={op} value={op}>{op}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-md-4 mb-3">
                                <label className="form-label">Estado</label>
                                <select
                                    className="form-select mx-1"
                                    name="estado"
                                    value={formularioPromocion.estado}
                                    onChange={manejadorPromocion}
                                >
                                    {["Activo", "Inactivo", "Agotado"].map((op) => (
                                        <option key={op} value={op}>{op}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-md-6 mb-3">
                                <label className="form-label">Fecha Inicio</label>
                                <input
                                    className={`form-control ${errorFechaInicio ? "is-invalid" : ""}`}
                                    type="date"
                                    name="fechaInicio"
                                    value={formularioPromocion.fechaInicio}
                                    onChange={manejadorPromocion}
                                    onBlur={() => {
                                        if (!formularioPromocion.fechaInicio) setErrorFechaInicio(true);
                                    }}
                                />
                                {errorFechaInicio && (
                                    <div className="invalid-feedback">
                                        La fecha de inicio es requerida y debe ser anterior a la fecha fin.
                                    </div>
                                )}
                            </div>
                            <div className="col-md-6 mb-3">
                                <label className="form-label">Fecha Fin</label>
                                <input
                                    className={`form-control ${errorFechaFin ? "is-invalid" : ""}`}
                                    type="date"
                                    name="fechaFin"
                                    value={formularioPromocion.fechaFin}
                                    onChange={manejadorPromocion}
                                    onBlur={() => {
                                        if (!formularioPromocion.fechaFin) setErrorFechaFin(true);
                                    }}
                                />
                                {errorFechaFin && (
                                    <div className="invalid-feedback">
                                        La fecha de fin es requerida y debe ser posterior a la fecha inicio.
                                    </div>
                                )}
                            </div>
                            <div className="col-md-6 mb-3">
                                <label className="form-label">Hora Inicio</label>
                                <input
                                    className={`form-control ${errorHoraInicio ? "is-invalid" : ""}`}
                                    type="time"
                                    name="hora_inicio"
                                    value={formularioPromocion.hora_inicio}
                                    onChange={manejadorPromocion}
                                    onBlur={() => {
                                        if (!formularioPromocion.hora_inicio) setErrorHoraInicio(true);
                                    }}
                                />
                                {errorHoraInicio && (
                                    <div className="invalid-feedback">La hora de inicio es requerida.</div>
                                )}
                            </div>
                            <div className="col-md-6 mb-3">
                                <label className="form-label">Hora Fin</label>
                                <input
                                    className={`form-control ${errorHoraFin ? "is-invalid" : ""}`}
                                    type="time"
                                    name="hora_fin"
                                    value={formularioPromocion.hora_fin}
                                    onChange={manejadorPromocion}
                                    onBlur={() => {
                                        if (!formularioPromocion.hora_fin) setErrorHoraFin(true);
                                    }}
                                />
                                {errorHoraFin && (
                                    <div className="invalid-feedback">La hora de fin es requerida.</div>
                                )}
                            </div>
                            <div className="col-12 mb-3">
                                <label className="form-label">Días de la Semana</label>
                                <div className="d-flex flex-wrap">
                                    {dias.map((dia) => (
                                        <div
                                            key={dia}
                                            className="form-check me-4 mb-2"
                                            style={{ minWidth: "120px" }}
                                        >
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                id={`dia-${dia}`}
                                                checked={formularioPromocion.diasSemana.split(",").includes(dia)}
                                                onChange={(e) => handleDiasSemanaChange(dia, e.target.checked)}
                                            />
                                            <label className="form-check-label ms-2" htmlFor={`dia-${dia}`}>
                                                {dia}
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="col-md-4 mb-3">
                                <label className="form-label">Descuento Total (L)</label>
                                <input
                                    className={`form-control ${errorLimiteTotal ? "is-invalid" : ""}`}
                                    type="number"
                                    step="0.01"
                                    name="descuentoTotal"
                                    value={formularioPromocion.descuentoTotal}
                                    onChange={manejadorPromocion}
                                />
                                {errorLimiteTotal && (
                                    <div className="invalid-feedback">Ingrese un valor numérico válido.</div>
                                )}
                            </div>
                            <div className="col-md-4 mb-3">
                                <label className="form-label">Límite Total</label>
                                <input
                                    className={`form-control ${errorLimiteTotal ? "is-invalid" : ""}`}
                                    type="number"
                                    name="limite_total"
                                    value={formularioPromocion.limite_total}
                                    min="0"
                                    onChange={(e) => {
                                        const value = parseInt(e.target.value, 10);
                                        if (value >= 0 || isNaN(value)) {
                                            manejadorPromocion(e);
                                        }
                                    }}
                                    onBlur={() => {
                                        if (
                                            formularioPromocion.limite_total !== "" &&
                                            (isNaN(formularioPromocion.limite_total) || formularioPromocion.limite_total < 0)
                                        ) {
                                            setErrorLimiteTotal(true);
                                        }
                                    }}
                                />
                                {errorLimiteTotal && (
                                    <div className="invalid-feedback">Ingrese un valor numérico válido.</div>
                                )}
                            </div>
                            <div className="col-md-4 mb-3">
                                <label className="form-label">Límite por Cliente</label>
                                <input
                                    className={`form-control ${errorLimiteCliente ? "is-invalid" : ""}`}
                                    type="number"
                                    name="limite_cliente"
                                    value={formularioPromocion.limite_cliente}
                                    min="0"
                                    onChange={(e) => {
                                        const value = parseInt(e.target.value, 10);
                                        if (value >= 0 || isNaN(value)) {
                                            manejadorPromocion(e);
                                        }
                                    }}
                                    onBlur={() => {
                                        if (
                                            formularioPromocion.limite_cliente !== "" &&
                                            (isNaN(formularioPromocion.limite_cliente) || formularioPromocion.limite_cliente < 0)
                                        ) {
                                            setErrorLimiteCliente(true);
                                        }
                                    }}
                                />
                                {errorLimiteCliente && (
                                    <div className="invalid-feedback">Ingrese un valor numérico válido.</div>
                                )}
                            </div>
                        </div>
                        {renderDetallePromocionProductos()}
                    </Card>
                </div>
            </div>
        </Page>
    );
};

export default EditarPromocion;